export default "__VITE_ASSET__Bl5Y0zkF__"